import { defineMessages } from 'react-intl';

type MessageKeys = 'closeChatPanelButtonLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		closeChatPanelButtonLabel: {
			id: 'ai-mate.main-chat.close-chat-panel-button-label',
			defaultMessage: 'Close chat',
			description: 'Label for the close chat button',
		},
	});

export default message;
